import { actionCreator } from '@ardoq/rxbeach';

export const bypassLimitAction = actionCreator('[spiderChart] BYPASS_LIMIT');
